import React, { createContext, useContext, useState, useCallback } from 'react';
import de from './de';
import en from './en';

const dictionaries = { de, en };

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('language');
    return saved || 'de';
  });

  const toggleLanguage = () => {
    setLanguage(prev => {
      const next = prev === 'de' ? 'en' : 'de';
      localStorage.setItem('language', next);
      return next;
    });
  };

  const t = useCallback((key, params) => {
    const dict = dictionaries[language] || dictionaries.de;
    let text = dict[key];

    // Fallback to German if key not found
    if (text === undefined) {
      text = dictionaries.de[key];
    }

    // If still not found, return the key itself
    if (text === undefined) {
      return key;
    }

    // Interpolation: replace {param} with values
    if (params && typeof text === 'string') {
      Object.keys(params).forEach(param => {
        text = text.replace(new RegExp(`\\{${param}\\}`, 'g'), params[param]);
      });
    }

    return text;
  }, [language]);

  const value = {
    language,
    toggleLanguage,
    t
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};
